<template>
  <v-img eager :src="topLeftWaveImg" @error="topLeftWaveImgError"
         class="top-left-wave hidden-sm-and-down"></v-img>

  <v-img eager :src="logoSrc" @error="logoErrorSrc" class="top-logo hidden-sm-and-down"></v-img>

  <v-app-bar fixed flat :elevation="isScrolled ? 4 : 0" :class="{ 'is-scrolled': isScrolled }" class="px-6">

    <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>

    <v-img eager :src="logoDarkSrc" @error="logoDarkErrorSrc" class="logo-toolbar"
           :style="((!isScrolled && width <= 959) || isScrolled) ? 'opacity: 1' : 'opacity: 0'"
    ></v-img>

    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-sm-and-down" v-for="item in lang.header.items" :key="item.url">
      <v-btn variant="text" :href="item.url" :class="{ 'active-nav': activeSection === item.url && isScrolled }">
        {{ item.caption }}
      </v-btn>
    </v-toolbar-items>

    <v-btn class="ml-4 hidden-sm-and-down bg-grey-darken-3" href="#contact">{{ lang.header.contact }}</v-btn>

  </v-app-bar>

  <v-navigation-drawer v-model="drawer" fixed temporary>
    <v-list-item v-for="item in lang.header.items" :key="'m_' + item.url" @click="scrollToSection(item.url)" link>
      <v-list-item-title :class="{ 'active-nav': activeSection === item.url && isScrolled }">{{
          item.caption
        }}
      </v-list-item-title>
    </v-list-item>
    <v-list-item @click="scrollToSection('#contact')" link>
      <v-list-item-title>{{ lang.header.contact }}</v-list-item-title>
    </v-list-item>
  </v-navigation-drawer>

  <topSection></topSection>
</template>

<style>
.active-nav {
  background-color: whitesmoke;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.top-logo {
  position: absolute;
  width: 200px;
  top: 5px;
  left: 10%;
  z-index: 50;
}

.top-left-wave {
  position: absolute;
  z-index: 1;
  width: 600px;
  left: 0;
  top: 0;
  transform-origin: top;
  animation: animateWave 2000ms cubic-bezier(0.23, 1, 0.32, 1) forwards;
}

.logo-toolbar {
  position: fixed;
  min-width: 100px;
  min-height: 100px;
  left: 20%;
}

@media (max-width: 959px) {
  .logo-toolbar {
    left: calc(50% - 50px);
    display: flex !important;
  }

  .v-navigation-drawer__content {
    padding-top: 5px;
  }
}

@media (max-width: 1263px) {
  .top-logo {
    width: 150px;
    left: 10px;
  }
}

@media (min-width: 960px) {
  .logo-toolbar {
    left: 20px;
  }
}

@media (min-width: 1080px) {
  .top-logo {
    width: 200px;
    left: 5%;
  }

  .logo-toolbar {
    left: 14%;
  }
}

@media (min-width: 1264px) {
  .top-logo {
    left: 10%;
  }
}

@media (min-width: 1550px) {
  .logo-toolbar {
    left: 12%;
  }
}
</style>

<script setup>
import {useDisplay} from 'vuetify'

const {width} = useDisplay()
</script>

<script>
import lang from '@/lang/lang.js'
import topSection from "@/components/topSection.vue";

export default {
  components: {topSection},
  data: () => ({
    lang: lang,
    drawer: false,
    isScrolled: false,
    topLeftWaveImg: '/images/topSection/topLeftWave.webp',
    topLeftWaveImgError: '/images/topSection/topLeftWave.png',
    logoSrc: '/images/core/logo.webp',
    logoErrorSrc: '/images/core/logo.png',
    logoDarkSrc: '/images/core/logo_dark.webp',
    logoDarkErrorSrc: '/images/core/logo_dark.png',
    activeSection: '',
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0
      const sections = this.lang.header.items.map(item => ({
        id: item.url.replace('#', ''),
        el: document.querySelector(item.url)
      })).filter(s => s.el)

      for (const section of sections) {
        const rect = section.el.getBoundingClientRect()
        if (rect.top <= 80 && rect.bottom > 80) {
          this.activeSection = `#${section.id}`
          break
        }
      }
    },
    scrollToSection(target) {
      const el = document.querySelector(target)
      if (el) {
        el.scrollIntoView({behavior: 'smooth'})
        this.drawer = false
      }
    }
  }
}
</script>